import DeleteIcon from "@mui/icons-material/Delete";
import { Menu } from "@mui/material";
import { useState } from "react";

import { ConfirmationDialog } from "@/components/molecules/ConfirmationDialog";
import { BankAccount } from "@/interfaces/talk2pay.iterfaces";
import { BankAccountDialogMessages } from "@/messages/platforms/talk2PayHome/bank-account-dialog.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: BankAccountDialogMessages;
  selected: BankAccount;
  onRemove: (account: BankAccount) => void;
  openDialog: (isEditing: boolean, account?: BankAccount) => void;
}

function Popover({ isOpen, anchorEl, onClose, messages, selected, onRemove }: Props) {
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => setDialogOpen(true);
  const handleCloseDialog = () => setDialogOpen(false);

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        icon={<DeleteIcon />}
        title={messages.removePopover}
        onClick={handleOpenDialog}
      />

      <ConfirmationDialog
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        onConfirm={() => {
          onRemove(selected);
          handleCloseDialog();
        }}
        titleText={messages.deleteAccountDialogTitle}
        descriptionText={messages.deleteAccountDialogContent}
        cancelText={messages.deleteAccountDialogCancel}
        confirmText={messages.deleteAccountDialogConfirm}
        isLoading={false}
      />
    </Menu>
  );
}

export default Popover;
